<template>
  <div>
    <el-dialog title="我要举报" :visible.sync="dialogFormVisible" :lock-scroll="false" @close="closedia">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item label="举报信息：">
          <el-input v-model="title" disabled=""></el-input>
        </el-form-item>
        <el-form-item label="投诉类别：" prop="reType"><br>
          <el-select v-model="ruleForm.reType" placeholder="请选择投诉类别" style="width: 100%">
            <el-option label="无效联系方式" value="0"></el-option>
            <el-option label="虚假信息" value="1"></el-option>
            <el-option label="提前付费" value="2"></el-option>
            <el-option label="隐私侵犯" value="3"></el-option>
            <el-option label="其他" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="举报原因：" prop="content">
          <el-input type="textarea" placeholder="请详细填写举报原因。"
                    v-model="ruleForm.content" maxlength="200" show-word-limit></el-input>
        </el-form-item>
        <el-form-item prop="photo" label="证据截图" ><br>
          <upload ref='upload' @fileList="fileList"></upload>
        </el-form-item>
        <div style="color: #f39;text-align:left;font-weight: bold">* 请提供跟举报相关的证据图片，比如付款记录、聊天记录或者其他跟举报事宜有关的证据图片。带有证据图片的举报，将会被优先处理。</div><br>
        <div style="color: #f39;font-weight: bold">审核成功后，内容将在24小时内删除。</div><br>
        <div style="color: #f39;font-weight: bold">本站邮箱：fengloukefu@gmail.com</div>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button type="primary" @click="report('ruleForm')" :loading="setReBtn">确 定</el-button>
      </div>
    </el-dialog>
    <div v-if="loading" class="C-PageLoading">
      <div class="Spinner spinner-grow text-primary"></div>
    </div>
    <div v-if="!loading" class="row">
      <el-col class="LeftPart">
        <!--基本详情-->
        <el-card shadow="never" :body-style="{padding: '16px',textAlign: 'left'}">
          <div class="imgrow">
            <div class="Picture" v-for="(item,index) of imgList" :key="index">
              <el-image
                class="imglist"
                :src="item"
                fit="cover"
                :preview-src-list="imgList">
              </el-image>
            </div>
          </div>
          <div class="G-title" style="margin-bottom: 5px"></div>
          <div class="InfoField">
            <div class="InfoHead">
                <span class="InfoTitle">
                  {{title}}
                </span>
              <div>
                <div class="ant-tag" v-if="type === 2">商家</div>
                <div class="ant-tag" v-if="type === 1">商家</div>
              </div>
            </div>
            <div class="text-secondary">
              <small class="pr-2">
                <svg-icon icon-class="time" style="fill:#999"></svg-icon>
                {{time}}
              </small>
              <small class="pr-2">
                <svg-icon icon-class="browse" style="fill:#999"></svg-icon>
                {{browse}}
              </small>
              <small class="pr-2">
                <svg-icon icon-class="seeuser" style="fill:#999"></svg-icon>
                {{privacy}}
              </small>
            </div>
            <div class="Profiles">
              <div class="Profile">
                <svg-icon icon-class="address" style="fill:#f39"></svg-icon>
                <span style="color: #ff3399">{{city}}</span>
              </div>
            </div>
            <div class="Profiles">
              <div class="Profile">
                <span class="font-weight-bold">小姐年龄：</span>
                {{age}}
              </div>
            </div>
            <div class="Profiles">
              <div class="Profile">
                <span class="font-weight-bold">小姐颜值：</span>
                {{face}}
              </div>
            </div>
            <div class="Profiles">
              <div class="Profile">
                <span class="font-weight-bold">消费水平：</span>
                {{price}}
              </div>
            </div>
            <div class="Profiles">
              <div class="Profile">
                <span class="font-weight-bold">服务项目：</span>
                {{project}}
              </div>
            </div>
            <div>
              <el-button plain @click="reportBtn" size="mini">
                <svg-icon icon-class="report" style="fill:#f39"></svg-icon>
                 我要举报
              </el-button>
              <el-button plain size="mini" @click="click_fav" v-if="fav === 0">
                <svg-icon icon-class="noheart" style="fill:#f39"></svg-icon>
                 我要收藏
              </el-button>
              <el-button plain size="mini" @click="click_fav" v-if="fav === 1">
                <svg-icon icon-class="heart" style="fill:#f39"></svg-icon>
                 取消收藏
              </el-button>
            </div>
          </div>
        </el-card>
        <el-card shadow="never" :body-style="{padding: '16px',textAlign: 'left'}">
          <div style="text-align: center">
            <svg-icon icon-class="warring" style="fill:#f39;font-size: 40px"></svg-icon>
          </div>
          <p>本站为信息分享平台，并不对寻欢经历负责，请注意个人防范。凡是有要求路费/上门/红包/定金/保证金/照片验证/视频验证/提前付费等类似行为的都是骗子，同时也请注意任何形式的推荐办卡行为、引导下载APP行为，请勿上当受骗。碰到有问题的信息，请及时举报给我们删除信息。如果发布的信息涉及个人隐私，也请及时举报，我们会核实后第一时间帮你删除处理。</p>
        </el-card>
        <!--联系方式-->
        <el-card shadow="never" style="user-select: auto" :body-style="{padding: '16px',textAlign: 'left'}">
          <div class="InfoField" v-if="!$store.getters.Flag">
            <div class="G-title">
              <span><svg-icon icon-class="call" style="margin-right: 5px"></svg-icon>联系方式</span>
            </div>
            <div style="padding-top: 5px;" >
              <p style="font-size: 16px">您需要
              <router-link to="/login" style="color: #f39;font-size: 16px">登录</router-link>
                才可继续查看联系方式</p>
              <el-button plain @click="$router.push('/login')" size="medium" round>立即登录</el-button>
              <p>* 普通用户查看需要扣除{{points}}积分，你可以发布信息赚取积分或者升级VIP会员无限制查看。</p>
            </div>
          </div>
          <div class="InfoField" v-if="$store.getters.Flag">
            <div class="G-title">
              <span><svg-icon icon-class="call" style="margin-right: 5px"></svg-icon>联系方式</span>
            </div>
            <div v-if="is_see">
              <div class="Profiles" v-if="QQ">
                <div class="Profile">
                  <span class="g">QQ：</span>
                  <span>{{QQ}}</span>
                </div>
              </div>
              <div class="Profiles" v-if="wechat">
                <div class="Profile">
                  <span class="g">微信：</span>
                  <span>{{wechat}}</span>
                </div>
              </div>
              <div class="Profiles" v-if="yuni">
                <div class="Profile">
                  <span style="font-weight: bold">与你号：</span>
                  <span>{{yuni}}</span>
                </div>
              </div>
              <div class="Profiles" v-if="telegram">
                <div class="Profile">
                  <span style="font-weight: bold">Telegram：</span>
                  <span>{{telegram}}</span>
                </div>
              </div>
              <div class="Profiles" v-if="phone">
                <div class="Profile">
                  <span class="g">电话：</span>
                  <span>{{phone}}</span>
                </div>
              </div>
              <div class="Profiles" v-if="address">
                <div class="Profile">
                  <span class="g">地址：</span>
                  <span>{{address}}</span>
                </div>
              </div>
            </div>
            <div v-if="!is_see && !is_points">
              <div style="padding-top: 5px;" >
                <p style="font-size: 16px">本信息将会扣除
                  <span style="color: #f39;font-size: 16px">{{points}}</span>
                  积分，你积分不足或者VIP已过期，你可以通过发布信息赚取积分或者升级VIP无限制查看联系方式。
                </p>
              </div>
            </div>
            <div v-if="is_points">
              <div style="padding-top: 5px;" >
                <p style="font-size: 16px">本信息将会扣除
                  <span style="color: #f39;font-size: 16px">{{points}}</span>
                  积分，你可以使用积分购买该信息！
                </p>
              </div>
            </div>
            <div class="Profiles">
              <div class="Profile">
                <el-popconfirm title="确定要用积分购买吗？" @confirm="buy" v-if="is_points">
                  <el-button size="small"  slot="reference"><span style="font-size: 14px">积分购买</span></el-button>
                </el-popconfirm>
                <router-link to="/upgrade" style="color: #f39" v-if="!is_see" class="navbar-nav">
                  <el-button size="small"><span style="font-size: 14px">升级VIP</span></el-button>
                </router-link>
                <router-link to="/publish" style="color: #f39" v-if="!is_see" class="navbar-nav">
                  <el-button size="small"><span style="font-size: 14px">发布信息</span></el-button>
                </router-link>
              </div>
            </div>
          </div>
        </el-card>
        <!--详情介绍-->
        <el-card shadow="never" :body-style="{padding: '16px',textAlign: 'left'}">
          <div class="InfoField">
            <div class="G-title">
              <span><svg-icon icon-class="sex" style="margin-right: 5px;"></svg-icon>详情介绍</span>
            </div>
            <div><p class="mb-2" style=" white-space: pre-line !important;">{{process}}</p></div>
          </div>
        </el-card>
      </el-col>
      <RightPart @get_show="right_id" :r_data="r_data"></RightPart>
    </div>
  </div>
</template>

<script>
import upload from '../widget/upload'
import RightPart from '@/components/widget/RightPart'
import {request} from '../../network/request'
export default {
  name: 'show',
  components: {RightPart, upload},
  data () {
    let validateContent = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('举报原因不能为空'))
      } else if (value.length < 10 || value.length > 200) {
        callback(new Error('举报原因 必须介于 10 - 200 个字符之间。'))
      } else {
        callback()
      }
    }
    let validateRetype = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择举报原因'))
      } else {
        callback()
      }
    }
    return {
      setReBtn: false,
      loading: true,
      // 传入推荐的值
      r_data: [],
      // 信息详情
      is_points: false,
      is_see: true,
      type: 0,
      id: this.$route.query.id,
      title: '',
      time: '',
      browse: '',
      city: '',
      cid: '',
      age: '',
      face: '',
      price: '',
      project: '',
      points: 0,
      QQ: '',
      wechat: '',
      telegram: '',
      yuni: '',
      phone: '',
      address: '',
      process: '',
      privacy: '',
      imgList: [],
      fav: 0,
      // 举报
      dialogTableVisible: false,
      dialogFormVisible: false,
      dialogIdentify: false,
      dialogInfo: false,
      ruleForm: {
        fileList: '',
        reType: '',
        content: '' // 举报信息的简述
      },
      rules: {
        content: [
          {validator: validateContent, trigger: 'blur'}
        ],
        reType: [
          {validator: validateRetype, trigger: 'blur'}
        ]
      }
    }
  },
  watch: {
    '$route': {
      handler (newVal) {
        this.ruleForm.content = ''
        this.ruleForm.reType = ''
        if (!this.$route.query.id) {
          this.loading = true
        } else {
          this.loading = true
          this.id = this.$route.query.id
          this.get_data(this.id)
        }
      }
    }
  },
  created () {
    if (!this.$route.query.id) {
      this.loading = true
    } else {
      this.get_data(this.id)
    }
  },
  methods: {
    closedia () {
      this.$refs.upload.$refs.pictureUpload.clearFiles()
      this.ruleForm.fileList = ''
    },
    fileList: function (fileList) {
      // childValue就是子组件传过来的值
      this.ruleForm.fileList = fileList
    },
    reportBtn () {
      if (this.$store.getters.Flag && localStorage.getItem('Flag')) {
        this.dialogFormVisible = true
      } else {
        this.$message.error('请先登录')
      }
    },
    report (ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          if (this.$store.getters.Flag && localStorage.getItem('Flag')) {
            this.setReBtn = true
            let data = new URLSearchParams()
            data.append('type', this.ruleForm.reType)
            data.append('content', this.ruleForm.content)
            data.append('did', this.id)
            data.append('fileList', JSON.stringify(this.ruleForm.fileList))
            request({
              url: '/api/report',
              method: 'post',
              data: data
            }).then(res => {
              if (res.data.status === 0) {
                this.$message.success('成功提交')
                this.setReBtn = false
              } else if (res.data.status === 1) {
                this.$message.error('请不要重复提交')
                this.setReBtn = false
              } else if (res.data.status === 2) {
                this.$message.error('请不要频繁举报，隔日再试')
                this.setReBtn = false
              } else if (res.data.status === 3) {
                this.$message.error('该贴不存在')
                this.setReBtn = false
              } else {
                this.$message.error('网络异常')
                this.setReBtn = false
              }
              this.ruleForm = {
                reType: '',
                content: ''
              }
              this.dialogFormVisible = false
            }).catch(err => {
              this.setReBtn = false
              console.log(err)
            })
          } else {
            this.$message.error('请先登录')
          }
        }
      })
    },
    buy () {
      if (this.$store.getters.Flag && localStorage.getItem('Flag')) {
        let data = new URLSearchParams()
        data.append('did', this.id)
        request({
          url: '/api/buy',
          method: 'post',
          data: data
        }).then(res => {
          if (res.data.status === 0) {
            this.get_data(this.id)
            setTimeout(() => {
              this.$message.success('成功购买')
            }, 100)
          } else {
            this.$message.error('购买失败')
          }
        }).catch(err => {
          console.log(err)
        })
      } else {
        this.$message.error('请先登录')
      }
    },
    click_fav () {
      if (this.$store.getters.Flag && localStorage.getItem('Flag')) {
        let data = new URLSearchParams()
        data.append('did', this.id)
        request({
          url: '/api/fav',
          method: 'post',
          data: data
        }).then(res => {
          if (res.data.status === 2) {
            this.$message.error('该贴不存在！')
          } else {
            this.fav = res.data.status
          }
        }).catch(err => {
          console.log(err)
        })
      } else {
        this.$message.error('请先登录')
      }
    },
    right_id (id) {
      this.loading = true
      this.id = id
      this.get_data(id)
    },
    get_data (id) {
      let data = new URLSearchParams()
      data.append('id', id)
      request({
        url: '/api/show',
        method: 'post',
        data: data
      }).then(res => {
        this.yuni = res.data.yuni
        this.telegram = res.data.telegram
        this.title = res.data.title
        this.time = res.data.time
        this.browse = res.data.browse
        this.city = res.data.city
        this.cid = res.data.cid
        this.age = res.data.age
        this.face = res.data.face
        this.price = res.data.price
        this.project = res.data.project
        this.QQ = res.data.QQ
        this.wechat = res.data.wechat
        this.phone = res.data.phone
        this.address = res.data.address
        this.process = res.data.process
        this.imgList = res.data.imgList
        this.type = res.data.type
        this.points = res.data.points
        this.r_data = res.data.r_data
        this.fav = res.data.fav
        this.is_points = res.data.is_points
        this.is_see = res.data.is_see
        this.privacy = res.data.privacy
        this.loading = false
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style scoped>
  p {
    display: block;
    font-size: .875rem;
    line-height: 1.5rem;
  }
  .p4 {
    font-size: 14px;
    color: #f39;
  }
  .row {
    margin: -8px 0 0 !important;
    justify-content: space-between !important;
    display: flex;
    flex-wrap: wrap;
  }
  .InfoTitle {
    font-size: 16px;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .text-secondary {
    color: #999 !important;
  }

  small {
    font-size: 80%;
    font-weight: 400;
  }

  .pr-2 {
    padding-right: .5rem !important;
  }

  .Profiles {
    padding: 0 !important;
    margin-right: auto;
    margin-left: auto;
    width: 100%;
  }

  .font-weight-bold {
    font-weight: 700 !important;
  }

  .svg-icon {
    width: 1.1em;
    height: 1.1em;
    vertical-align: -0.2em;
    fill: currentColor;
  }

  .G-title {
    font-size: 16px;
    border-bottom: 1px solid #f2f2f2 !important;
    color: #333 !important;
    padding: 5px;
    justify-content: space-between !important;
    display: flex !important;
  }

  .g {
    display: inline-block;
    width: 42px;
    font-weight: 700 !important;
  }
  .imgrow{
    display: grid;
    grid-template-columns: repeat(4,minmax(0,1fr));
  }
  .Picture {
    box-sizing:border-box;
    justify-content: center;
    align-items: flex-start;
    position: relative;
    padding-left: 5px;
    padding-top: 5px;
  }
  .imglist{
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  img{
    border-style: none;
    vertical-align: middle;
  }
  .mb-2{
    font-size: 14px
  }
  a:hover{
    text-decoration:underline;
  }
  .text-dark {
    color: black;
    font-weight: 700 !important;
    margin-top: .5rem !important;
    margin-bottom: .5rem !important;
    font-size: 14px;
  }
  .m2 {
    margin-bottom: .5rem;
    margin-top: .5rem;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/show.vue